/* Info component for the Characters Create page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/PostCreateEditForm.module.css";

const ImportLocs = () => {
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
         <div className={`px-3 py-2 mt-2 ${styles.SubTitle6}`}>
          <p className={`${styles.Red} text-center`}>LOCATIONS INFO</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={`pt-2`}>
          * Create a Location for every new Script Heading Location.</p>
          <p className={`pt-2`}>
          * If a Location has <span className={`${styles.Red}`}>Sublocations</span> create a
          separate new Location for each, e.g. "Jack's Bar - Lounge", "Jack's Bar - Cellar" etc.
          </p>
          <p className="pt-2">
          * <span className={`${styles.Red}`}>Important!</span> Location Names and Addresses are 
          passed to the Schedule's "Filming Location" dropdown so they must be added here.
          </p>
          <p className="pt-2">
          * <span className={`${styles.Red}`}>Important!</span> Location Names, Addresses and Notes
           automatically display on Callsheets so they must be added or updated here first.
          </p>
          <p className={`pt-2`}>
          * Add Location Images and the above details on the Location Edit page.
          </p>
          <p className={`pt-3 ${styles.SmallWhite}`}>
          Note: Moodboards and Scene Workshops are to be used to collaborate the Location before final choices are made.
          </p>
          <p className={`pt-2 ${styles.SmallWhite}`}>
          Note: The Callsheet contains a Primary Nearest Hospital field for that Day's Shoot 
          so adding the Nearest Hospital here is optional.
          </p> 
          <hr className={`mt-2 mb-0`}/>
        </div>
        </Col>
      </Row>
    </div>
  )
}

export default ImportLocs